import { useState, useEffect } from 'react'
import { formatearPeso } from '../../utils/formato'

export default function ListaProductos({ productos, onAgregar }) {
  const [busqueda, setBusqueda] = useState('')
  const [filtrados, setFiltrados] = useState([])

  useEffect(() => {
    if (!busqueda.trim()) {
      setFiltrados([])
      return
    }
    const t = busqueda.toLowerCase()
    setFiltrados(
      productos.filter(p =>
        p.nombre.toLowerCase().includes(t) ||
        (p.categoria && p.categoria.toLowerCase().includes(t))
      )
    )
  }, [busqueda, productos])

  function handleBusqueda(valor) {
    const exacto = productos.find(p => p.codigoBarras && p.codigoBarras === valor.trim())
    if (exacto) {
      onAgregar(exacto)
      setBusqueda('')
      return
    }
    setBusqueda(valor)
  }

  return (
    <div className="flex flex-col h-full">
      {/* Buscador */}
      <div className="p-3 sticky top-0 bg-tienda-bg z-10">
        <div className="relative">
          <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-tienda-muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            type="text"
            value={busqueda}
            onChange={e => handleBusqueda(e.target.value)}
            placeholder="Buscar producto..."
            className="input-field pl-10 text-base py-2.5"
          />
          {busqueda && (
            <button
              onClick={() => setBusqueda('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-tienda-muted p-1"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Lista */}
      <div className="flex-1 overflow-y-auto px-3 pb-3 space-y-2">
        {!busqueda.trim() ? (
          <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
            <svg className="w-12 h-12 text-tienda-border" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <p className="text-tienda-muted text-base">Escribe para buscar un producto</p>
          </div>
        ) : filtrados.length === 0 ? (
          <p className="text-center text-tienda-muted py-8 text-lg">Sin resultados</p>
        ) : (
          filtrados.map(producto => (
            <ProductoCard key={producto._id} producto={producto} onAgregar={onAgregar} />
          ))
        )}
      </div>
    </div>
  )
}

function ProductoCard({ producto, onAgregar }) {
  const sinStock = typeof producto.stock === 'number' && producto.stock <= 0
  const stockBajo = typeof producto.stock === 'number' && producto.stock > 0 && producto.stock <= 5

  return (
    <button
      onClick={() => !sinStock && onAgregar(producto)}
      disabled={sinStock}
      className={`
        w-full card p-3 flex items-center gap-3 text-left
        active:scale-98 transition-transform duration-75
        ${sinStock ? 'opacity-40' : 'active:bg-tienda-border'}
      `}
    >
      <div className="w-12 h-12 rounded-xl bg-tienda-bg flex items-center justify-center text-2xl flex-shrink-0">
        {producto.emoji || producto.nombre.charAt(0).toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-tienda-text text-base truncate">{producto.nombre}</p>
        <div className="flex items-center gap-2 mt-0.5">
          {producto.categoria && (
            <span className="text-xs text-tienda-muted bg-tienda-bg px-2 py-0.5 rounded-full">
              {producto.categoria}
            </span>
          )}
          {sinStock && <span className="badge-danger">Agotado</span>}
          {stockBajo && <span className="text-xs text-tienda-accent font-semibold">Stock: {producto.stock}</span>}
        </div>
      </div>
      <div className="flex-shrink-0 text-right">
        <p className="text-tienda-accent font-bold text-lg">{formatearPeso(producto.precio)}</p>
      </div>
    </button>
  )
}
